import { px2rem } from '../utils/helpers/style.js';

/**
 * This is an auto generated file - do not modify manually!
 * Spacings are fetched via Figma api
 */
var spacingNumerical = {
  /**
   * 'none' spacing: 0px
   */
  none: 0,

  /**
   * 'xxxxs' spacing: 4px
   */
  xxxxs: 4,

  /**
   * 'xxxs' spacing: 8px
   */
  xxxs: 8,

  /**
   * 'xxs' spacing: 16px
   */
  xxs: 16,

  /**
   * 'xs' spacing: 24px
   */
  xs: 24,

  /**
   * 's' spacing: 32px
   */
  s: 32,

  /**
   * 'm' spacing: 40px
   */
  m: 40,

  /**
   * 'l' spacing: 56px
   */
  l: 56,

  /**
   * 'xl' spacing: 64px
   */
  xl: 64,

  /**
   * 'xxl' spacing: 80px
   */
  xxl: 80,

  /**
   * 'xxxl' spacing: 120px
   */
  xxxl: 120
};
var spacing = {
  /**
   * 'none' spacing: 0px
   */
  none: 0,

  /**
   * 'xxxxs' spacing: 4px
   */
  xxxxs: px2rem(4),

  /**
   * 'xxxs' spacing: 8px
   */
  xxxs: px2rem(8),

  /**
   * 'xxs' spacing: 16px
   */
  xxs: px2rem(16),

  /**
   * 'xs' spacing: 24px
   */
  xs: px2rem(24),

  /**
   * 's' spacing: 32px
   */
  s: px2rem(32),

  /**
   * 'm' spacing: 40px
   */
  m: px2rem(40),

  /**
   * 'l' spacing: 56px
   */
  l: px2rem(56),

  /**
   * 'xl' spacing: 64px
   */
  xl: px2rem(64),

  /**
   * 'xxl' spacing: 80px
   */
  xxl: px2rem(80),

  /**
   * 'xxxl' spacing: 120px
   */
  xxxl: px2rem(120)
};

export { spacing, spacingNumerical };
